/* globals angular */
(function() {
  'use strict';

  function ShippingConfigResource($resource, URLAPIPEDIDO) {
    return $resource(URLAPIPEDIDO, {}, {
      getOptions: {
        method: 'GET',
        url: URLAPIPEDIDO + '/v1/configuracaoopcao',
        isArray: true,
      }
    });
  }

  angular
    .module('mandaeApp')
    .factory('ShippingConfigResource', ShippingConfigResource);
})();
